import guizhouInspectGroup from "./index.vue";
import guizhouInspectGroupHome from "./Home.vue";

const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/guizhouInspectGroupIndex",
    name: "guizhouInspectGroupIndex",
    component: guizhouInspectGroupHome
  },
  {
    path: "/guizhouInspectGroup/login",
    name: "guizhouInspectGroupLogin",
    component: login
  },
  {
    path: "/guizhouInspectGroup",
    name: "guizhouInspectGroup",
    redirect: "/guizhouInspectGroup",
    component: guizhouInspectGroup,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
